import React from 'react';
import '../.././components/css/popupstyle.css';
import $ from 'jquery';
import { userService } from '../../_services';
import { debuglog } from 'util';

class OverridePopup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            UserDataList: [],
            SearchDispay: [],
            error: '',
            loading: false,
            userdata: JSON.parse(localStorage.getItem('user')),
            deleteIndex: 0,
            IsUserAvail: false,
            disNameError: '',
            disEmailError: '',
            disPhoneError: '',
            disCommissionError: '',
            isusersearched: '',
            newUser: this.props.chkUser,
            IsBroker: false,
            renderList: [],
            campaignList: [],
            submitDisabled: true,
            currentEmail: ''
        };
    }

    componentDidMount() {
        this.GetUserList_All(this.state.userdata.paramsname, this.props.SelectedGroupNumber, this.props.userType);
        setTimeout(() => {
            if (this.state.userdata.paramsname.toLowerCase() == 'patient rx discount') {
                this.setState({ submitDisabled: true });
            } else {
                this.setState({ submitDisabled: false });
            }
        }, 700)
    }

    // get data from api
    GetUserList_All(WhName, GroupNumber, userType) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
                body: JSON.stringify({ WhName, GroupNumber })
            };
            return fetch(`/api/ws/groupnamedetails`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0 && apidata[0].distributor_UserId != "0") this.setState({ IsUserAvail: true });
                        let APIResponse = JSON.parse(JSON.stringify(apidata));
                        APIResponse.forEach(function (a) {
                            if (a.distributorCommission == "0")
                                a.distributorCommission = "1.75";
                        });
                        let newUserList = APIResponse;
                        newUserList.forEach(function (a) {
                            a.userType = userType
                        });
                        this.setState({ UserDataList: newUserList });
                        if (this.props.chkUser == 'false') {
                            this.Get_Searched_Distributor_Logs(this.props.disEmail, this.props.userType, this.state.userdata.wholesaler_Id.toString());
                        }
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    // handle response
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    handleChange = (e) => {
        const { name, value } = e.target;
        // this.setState({ [name]: value });
        let prods = this.state.UserDataList;
        $('.help-block').html('');
        // get current type
        var dataType = $(e.target).attr('data-type');
        if (dataType == 'emailId') {
            let currentEmail = this.state.currentEmail;
            let isEmail = true;
            prods.forEach(function (a) {
                a.emailId = value;
                if (currentEmail != a.emailId) {
                    isEmail = false;
                }
            });
            let newUserList = prods;
            if (isEmail) {
                this.setState({ UserDataList: newUserList, isusersearched: 'yes', disEmailError: '', error: '' });
            } else {
                let temp = this.state.UserDataList;
                temp[0].distributorName = '';
                temp[0].phoneNumber = '';
                temp[0].distributorCommission = '';
                this.setState({ UserDataList: temp, campaignList: [], isusersearched: 'yes', disEmailError: '', error: '' });
            }
            this.handleBlur();
        }
        if (dataType == 'phoneNumber') {
            prods.forEach(function (a) {
                a.phoneNumber = value;
            });
            let newUserList = prods;
            this.setState({ UserDataList: newUserList, isusersearched: 'yes', disPhoneError: '', error: '' });
            this.handleBlur();
        }
        if (dataType == 'distributorCommission') {
            prods.forEach(function (a) {
                a.distributorCommission = value;
            });
            let newUserList = prods;
            this.setState({ UserDataList: newUserList, isusersearched: 'yes', disCommissionError: '', error: '' });
            this.handleBlur();
        }
        if (dataType == 'distributorName') {
            prods.forEach(function (a) {
                a.distributorName = value;
            });
            let newUserList = prods;
            this.setState({ UserDataList: newUserList, isusersearched: 'yes', disNameError: '', error: '' });
        }
        if (dataType == 'userType') {
            prods.forEach(function (a) {
                a.userType = value;
            });
            let newUserList = prods;
            this.setState({ UserDataList: newUserList, isusersearched: 'yes', error: '' });
        }
    }
    handleBlur = e => {
        try {
            if (this.state.SearchDispay.length > 0) {
                this.setState({ IsBroker: false, SearchDispay: '' });
            }
        } catch (error) {}
    }
    EmailSearchKeyUp = e => {
        try {
            if (!this.state.IsUserAvail) {
                if ($('#DistEmail').val().length >= 0) {
                    this.Get_Searched_Distributor_Logs($('#DistEmail').val(), this.props.userType, this.state.userdata.wholesaler_Id.toString());
                }
                else {
                    this.setState({ SearchDispay: null, IsBroker: false, UserDataList: [] });
                }
            }
        } catch (error) { }
    }
    Get_Searched_Distributor_Logs(emailid, campaignType, WhName) {
        try {
            userService.SearchEmailCampaignType(emailid, campaignType, WhName).then(
                apidata => {
                    try {
                        if (emailid.length > 0) {
                            if (this.props.chkUser == 'false')
                                this.setState({ campaignList: apidata });
                            else 
                                this.setState({ SearchDispay: apidata, renderList: apidata, IsBroker: apidata[0].isBroker });
                        }
                        else {
                            let temp = this.state.UserDataList;
                            temp[0].emailId = '';
                            if (this.state.WhAdvanceSetting.isBroker == false) {
                                this.setState({ IsBroker: false, UserDataList: temp, SearchDispay: '' });
                            }
                            else {
                                this.setState({ IsBroker: true, UserDataList: temp, SearchDispay: '' });
                            }
                        }
                    }
                    catch (error) {

                    }
                }
            );
        }
        catch (error) {
            this.setState({ error: 'Opps!, Something went wrong. Try Again.' });
        }
    }
    HandleSearchItemClick = e => {
        try {
            let temp = this.state.UserDataList;
            temp[0].emailId = $(e.target).attr('data-email');
            temp[0].distributorName = $(e.target).attr('data-name');
            temp[0].phoneNumber = $(e.target).attr('data-phone');
            temp[0].distributorCommission = $(e.target).attr('data-commission');
            let filterCampaignList = this.state.renderList.filter((item) => item.emailId == $(e.target).attr('data-email'));
            this.setState({ SearchDispay: [], campaignList: filterCampaignList, UserDataList: temp, disNameError: '', disEmailError: '', currentEmail: $(e.target).attr('data-email')});
        }
        catch (error) {
            this.setState({ error: 'Opps!, Something went wrong. Try Again.' });
        }
    }
    distributorvalidation(UserData) {
        this.setState({ disNameError: '', disEmailError: '', disCommissionError: '', disPhoneError: '', error: '', loading: true, submitDisabled: true });
        let iCount = 0;
        // name validate
        if (!userService.Check_Null_Empty(UserData.distributorName)) {
            // condition to find dot
            if ((UserData.distributorName).indexOf('.') !== -1) {
                this.setState({ disNameError: 'Dot not allowed', loading: false, submitDisabled: false });
                iCount = iCount + 1;
            } else {
                let userNameRegex = /^\w+(\s\w+)*$/;

                if (userNameRegex.test(UserData.distributorName)) {
                    this.setState({ disNameError: '' });
                } else {
                    this.setState({ disNameError: 'Space not allowed', loading: false, submitDisabled: false });
                    iCount = iCount + 1;
                }
            }
        } else {
            this.setState({ disNameError: 'Name required', loading: false, submitDisabled: false });
            iCount = iCount + 1;
        }

        // email validate
        if (!userService.Check_Null_Empty(UserData.emailId)) {
            if (UserData.emailId.indexOf(' ') >= 0) {
                this.setState({ disEmailError: 'Space not allowed', loading: false, submitDisabled: false });
                iCount = iCount + 1;
            } else {

                if (userService.ValidateEmail(UserData.emailId)) {
                    this.setState({ disEmailError: '' });
                } else {
                    iCount = iCount + 1;
                    this.setState({ disEmailError: 'Invalid email', loading: false, submitDisabled: false });
                }
            }
        } else {
            this.setState({ disEmailError: 'Email required', loading: false, submitDisabled: false });
            iCount = iCount + 1;
        }
        // commission validate
        if (!userService.Check_Null_Empty(UserData.distributorCommission)) {

            if (UserData.distributorCommission.indexOf(' ') >= 0) {
                this.setState({ disCommissionError: 'Space not allowed', loading: false, submitDisabled: false });
                iCount = iCount + 1;
            } else {

                if (userService.validateCurrency(UserData.distributorCommission)) {
                    this.setState({ disCommissionError: '' });
                } else {
                    iCount = iCount + 1;
                    this.setState({ disCommissionError: 'Invalid Commission', loading: false, submitDisabled: false });
                }
            }

        } else {
            this.setState({ disCommissionError: 'Commission required', loading: false, submitDisabled: false });
            iCount = iCount + 1;
        }
        if (iCount == 0) {
            return true;
        }
    }
    CheckCommissionExceed() {
        try {
            let usercomm = 0;
            usercomm += parseFloat(this.state.UserDataList[0].distributorCommission);
            if (usercomm <= parseFloat(this.props.MaxComm) || this.state.UserDataList[0].IsRuleType)
                return true;
            else
                return false;
        } catch (error) { }
    }
    handleSaveSubmit = (e) => {
        try {
            if (this.state.userdata.paramsname.toLowerCase() == 'patient rx discount') {
                this.setState({ error: 'Patient rx discount not allowed', loading: false, submitDisabled: true });
            } else {
                if (this.distributorvalidation(this.state.UserDataList[0])) {
                    if (this.CheckCommissionExceed())
                        this.ProcessUserSubmitData(JSON.stringify(this.state.UserDataList), this.state.userdata.wholesaler_Id.toString(), this.props.SelectedGroupNumber, this.props.MaxComm);
                    else
                        this.setState({ error: 'The total commission for this group number exceeds the maximum allowed commission', loading: false, submitDisabled: false });
                }
            }
        } catch (error) { }
    }
    ProcessUserSubmitData(UserJson, WhName, GroupNumber, MaxComm) {
        try {
            userService.ProcessUserCampaign(UserJson, WhName, GroupNumber, MaxComm).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].code == "1") {
                                this.setState({ loading: false, error: apidata[0].message });
                                $('.save-btn').attr('disabled', true);
                            }
                            else {
                                this.setState({ loading: false, error: apidata[0].message, submitDisabled: false });
                            }
                        }
                        else {
                            this.setState({ loading: false, error: 'Whoops, something went wrong. Please try again', submitDisabled: false });
                        }
                    }
                    catch (error) {
                        this.setState({ loading: false, error: 'Whoops, something went wrong. Please try again', submitDisabled: false });
                    }
                }
            );
        }
        catch (error) {
            this.setState({ loading: false, error: 'Opps!, Something went wrong. Try Again.', submitDisabled: false });
        }
    }
    handleUserTypeOnChange = e => {
        try {
            this.handleBlur();
            this.state.UserDataList[0].userType = $('#userType').val();
            this.setState({ UserDataList: this.state.UserDataList });
        } catch (error) { }
    }
    handleBack = () => {
        try {
            this.props.closeCampaignPopup();
            this.props.openManageGroup(this.props.SelectedGroupNumber, this.props.MaxComm, this.props.cPagin, this.props.cSearch, '', '', this.props.reopenFlag, this.props.allData);
        } catch (error) { }
    }
    render() {
        const { loading, error, disNameError, disEmailError, disPhoneError, disCommissionError, campaignList, submitDisabled } = this.state;

        return (
            <div className='popup override-content'>
                <div className='popup_inner manage-distributor-design wh-edit-group campaignScreen'>
                    <h1>{this.props.text}<button onClick={this.handleBack}>X</button></h1>
                    <form name="form" id="mainForm" onSubmit={this.handleSubmit} className="referralPopup">

                        {this.state.UserDataList.length == 0 ? null :
                            <div>
                                <div className="field-data">
                                    <formgroup>
                                        <div className="col-lg-4">
                                            <label>Email: </label>
                                            <div className="searchSection distributor-search">
                                                <form autoComplete="off">
                                                    <div className="autocomplete">
                                                        {
                                                            this.state.UserDataList[0].emailId != "" && this.state.UserDataList[0].emailId != null && this.state.IsUserAvail ?
                                                                <input onChange={this.handleChange} type="text" id="DistEmail" className="form-control disinput" readOnly data-type="emailId" onKeyUp={this.EmailSearchKeyUp} value={this.state.UserDataList[0].emailId} /> :
                                                                <input onChange={this.handleChange} type="text" id="DistEmail" className="form-control disinput" data-type="emailId" onKeyUp={this.EmailSearchKeyUp} value={this.state.UserDataList[0].emailId} /> 
                                                        }
                                                        {
                                                            this.state.SearchDispay != null ? this.state.SearchDispay[0] ?
                                                                <div id="myInputautocomplete-list" className="autocomplete-items">
                                                                    {
                                                                        this.state.SearchDispay.map((item, index) => {
                                                                            return (
                                                                                <span data-phone={item.phoneNumber} data-commission={item.distributorCommission} data-email={item.emailId} data-name={item.distributorName} onClick={this.HandleSearchItemClick}>{item.distributorName}</span>
                                                                            )
                                                                        })}
                                                                </div> : null : null

                                                        }
                                                        {
                                                            disEmailError &&
                                                            <div className={'alert alert-danger m-group'}>{disEmailError}</div>
                                                        }
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 gap">
                                            <label>Name: </label>
                                            <input type="text" id="myDistInput" className="form-control disinput" data-type="distributorName" onChange={this.handleChange} value={this.state.UserDataList[0].distributorName} defaultValue={this.state.UserDataList[0].distributorName} />
                                            <input type="hidden" className="form-control disinput" name="disid" value={this.state.UserDataList[0].disId} />
                                            {
                                                disNameError &&
                                                <div className={'alert alert-danger m-group'}>{disNameError}</div>
                                            }
                                        </div>
                                        <div className="col-lg-4">
                                            <label>Phone Number: </label>
                                            <input type="text" name="phone" className="form-control disinput" data-type="phoneNumber" onChange={this.handleChange} value={this.state.UserDataList[0].phoneNumber} />
                                            {
                                                disPhoneError &&
                                                <div className={'alert alert-danger m-group'}>{disPhoneError}</div>
                                            }
                                        </div>
                                    </formgroup>
                                    <formgroup>
                                        <div className="col-lg-4">
                                            <label>Commission ($): </label>
                                            <input type="text" className="form-control disinput" name="commission" data-type="distributorCommission" onChange={this.handleChange} value={this.state.UserDataList[0].distributorCommission} />
                                            {
                                                disCommissionError &&
                                                <div className={'alert alert-danger m-group'}>{disCommissionError}</div>
                                            }
                                        </div>
                                    </formgroup>
                                </div>
                            </div>
                        }
                        <div className="clear"></div>
                        {
                            campaignList.length > 1 ? 
                                <div className="override-section">
                                    <table>
                                        <thead>
                                            <tr className={campaignList.length > 3 ? "header Sub header-scroll" : "header Sub" }>
                                                <th className="first-one">Group Number</th>
                                                <th className="second-one">Name</th>
                                                <th className="third-one">Email</th>
                                                <th className="fourth-one">Phone Number</th>
                                                <th className="fifth-one">Commission ($)</th>
                                            </tr>
                                        </thead>
                                        <tbody id="scroll-on">
                                            {
                                                campaignList.map((item) => {
                                                    return (
                                                        <tr className="userDashData SubDist_GroupBox">
                                                            <td className="first-one">{item.groupNumber}</td>
                                                            <td className="second-one">{item.distributorName}</td>
                                                            <td className="third-one">{item.emailId}</td>
                                                            <td className="fourth-one">{item.phoneNumber}</td>
                                                            <td className="fifth-one">{item.distributorCommission.toFixed(2)}</td>
                                                        </tr>
                                                        )
                                                })
                                            }
                                        </tbody>
                                    </table>

                                </div> : null
                        }
                        <div className="button-section manage-btn-section bottom-gap">
                            <input type="button" className={loading ? 'btn animated-btn save-btn' : 'btn save-btn'} onClick={this.handleSaveSubmit} value="Save & Submit" disabled={submitDisabled} />
                            <input type="button" onClick={this.handleBack} className="btn cancel" value="Cancel" />
                            {loading &&
                                <div className="theme-loader"></div>
                            }
                            {error &&
                                <div className={'alert alert-danger m-group'}>{error}</div>
                            }
                        </div>

                    </form>

                </div>
            </div >

        );
    }
}
export default OverridePopup;